<template>
  <BaseIndex
    ref="baseIndex"
    :modelNameSingular="modelNameSingular"
    :modelNamePlural="modelNamePlural"
    :pageLoading="pageLoading"
    :loading="loading"
    :table-headers="tableHeaders"
    :table-items="indexItems"
    :maskFields="maskFields"
    :infoHeaders="infoHeaders"
    @options-change="optionsChange"
    :serverItemsLength="totalItems"
    :loadOptions="options"
    :enableCustomFilters="true"
    :containTopToolbar="false"
    :typeOperators="typeOperators"
    :serverFields="serverFields"
    :changeSwitch="changeSwitch"
    @filter-confirm-action="applyFilters"
    :initialFilters="filters"
  >

    <!--<template slot="show" slot-scope="{ item }" v-if="$can('read', $router.currentRoute.name)">
      <Edit
        :entry="item"
        :readOnly="true"
        :modelNameSingular="modelNameSingular"
      />
    </template>   -->

    <!-- Gera a venda a partir do pedido -->
    <template slot="new" v-if="saleItemLots.length>0">
      <SaleNew
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :cropLotIds="saleItemLots"
        :inlineAddButton="false"
        newCreateButtonLabel="Criar Venda"
        newSaveButtonLabel="Salvar"
        modelNameSingular="Venda"
      />
    </template>

    <template slot="new" v-if="saleItemLots.length>0">
      <NewSeedPlotOperation 
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :cropLotIds="saleItemLots"
        :inlineAddButton="false"
        newCreateButtonLabel="Criar Operação"
        newSaveButtonLabel="Salvar"
        modelNameSingular="Operação"
      />
    </template>

    <template slot="action1" slot-scope="{ item }" v-if="item.availableQuantity>0">
      <Loss
        @entry-created="entryCreated"
        @entry-canceled="loadServerEntries()"
        :cropLotId="item.id"
        :inlineAddButton="true"
        :isLoss="true"
        newCreateButtonLabel="Gerar Perda"
        newSaveButtonLabel="Salvar"
        modelNameSingular="Perda"
      />
    </template>

  </BaseIndex>
</template>

<script>
import gql from 'graphql-tag'
import BaseIndex from "@shared_components/base_index.vue";
import SaleNew from "@models/sales/new.vue";
import Loss from "@models/storages/storage_adjustments/exit_storage_adjustments/new.vue";
import NewSeedPlotOperation from "@models/operations/seed_plot_operations/new.vue";
// import Edit from "./edit.vue";
// import Delete from "./delete.vue";
// import PlanningOperationShow from "../planning_operations/edit.vue"

export default {
  data() {
    return {
      indexItems: [],
      saleItemLots: [],
      loading: true,
      pageLoading: false,
      totalItems: 0,
      tableHeaders: [
        { text: "Lote", align: "left", sortable: true, value: "newName"},
        { text: "Estufas", align: "left", sortable: true, value: "storageName"},
        { text: "Variedades", align: "left", sortable: true, value: "varietyName"},
        { text: "Plantio", align: "left", sortable: true, value: "sownDate"},
        { text: "Qtd. Semeada", align: "left", sortable: true, value: "sown"},
        { text: "Qtd. Vendida", align: "left", sortable: true, value: "saleQuantity"},
        { text: "Perdas", align: "left", sortable: true, value: "lossQuantity"},
        { text: "Disponível", align: "left", sortable: true, value: "availableQuantity" },
        { text: "Selecionado", align: "left", sortable: false, value: "selected"},
        { text: "Ações", align: "left", sortable: false, value: "action" },
      ],
      maskFields: [
        { field: 'sownDate', mask: 'date'},
        // { field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }, 
        // { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
        { field: 'saleQuantity', mask: 'number_unit', unit: 'un' },
        { field: 'availableQuantity', mask: 'number_unit', unit: 'un' },
        { field: 'sown', mask: 'number_unit', unit: 'un' },
        { field: 'lossQuantity', mask: 'number_unit', unit: 'un' },
      ],
      infoHeaders: [
        // { field: 'varietyNames', info: 'Variedades, fertilizantes, agrotóxicos e biológicos consumidos nas operações. *Em operações de destinar semeios as variedades indicadas são as geradas.' },
        // { field: 'lots', info: 'Lotes semeados, em estufa ou aplicados'},
      ],
      options: { //objeto específico para configurar e armazenar as informações da paginação e ordenação.
        page: 1,
        itemsPerPage: 10,
        sortBy: ["id"],
        sortDesc: [true],
        groupBy: [],
        groupDesc: [],
        multiSort: false,
        mustSort: true
      },
      filters: [{field: "availableQuantity", fieldValues: [0], key: 0, operator: "gt", type: "decimal"}], //array para armazenar os filtros inseridos pelo usuário
      typeOperators: [], //array que traz do banco os operadores que serão utilizados nos filtros
      serverFields: [], // array que traz do banco quais os campos que podem ser aplicados filtros
    };
  },
  props: {
    modelNameSingular: {
      type: String,
      default: "Lote de Destinação"
    },
    modelNamePlural: {
      type: String,
      default: "Lotes de Destinação"
    },
  },
  components: {
    BaseIndex: BaseIndex,
    SaleNew: SaleNew,
    Loss: Loss,
    NewSeedPlotOperation: NewSeedPlotOperation,
    // New: New,
    // Edit: Edit,
    // Delete: Delete,
    // PlanningOperationShow: PlanningOperationShow
  },
  created() {    
    this.loadServerEntries();
  },
  computed: {
    // maskFields() {
    //   return [
    //     { field: 'sownDate', mask: 'date'},
    //     ... this.$vuetify.breakpoint.smAndDown ? [] : [{ field: 'periodsNamesList', mask: 'tag', color: 'success', outlined: true }], 
    //     { field: 'periodsTotalArea', mask: 'number_unit', unit: 'ha' },
    //   ]
    // }
  },
  methods: {
    applyFilters: function(filtersList) {
      this.filters = filtersList;
      this.options.page = 1;
      this.loadServerEntries();
    },
    loadServerEntries: function() {
      this.loading = true;
      console.log(this.filters);
      this.$apollo
        .query({
          query: LOAD_ALL_SEED_PLOT_OPERATIONS,
          variables: {
            input: { //todo index com paginação, ordenação e filtros server-side precisa enviar essas informações quando fizer a busca por dados
              limit: this.options.itemsPerPage,
              offset: (this.options.page - 1) * this.options.itemsPerPage,
              sortBy: this.options.sortBy,
              sortDesc: this.options.sortDesc,
              fields: this.tableHeaders.map(val => val.sortable ? (val.filter_value ? val.filter_value : val.value) : null).filter(val => val != null),
              filters: this.filters
            }
          },
          fetchPolicy: "no-cache"
        })
        .then(response => {
          // this.executionOperations = response.data.groundContext.allExecutionOperations;
          // console.log("All executionOperations", response.data.groundContext.executionOperationsIndex);
          this.indexItems = response.data.accountContext.availableCropLotsIndex.availableCropLots; //seta os itens retornados do servidor para o array de itens que será exibido na tabela

          // this.indexItems.forEach((item)=>{
          //   item.selected = "Não";
          // });
          
          this.totalItems = response.data.accountContext.availableCropLotsIndex.count; // seta o numero total de itens, como a paginação limita a quantidade de itens, o componente precisa saber qual o máximo de itens para configurar o componente na interface e calcular o número de páginas 
          this.typeOperators = response.data.accountContext.availableCropLotsIndex.typeOperators; //seta os operadores que podem ser utilizados nos filtros
          this.serverFields = response.data.accountContext.availableCropLotsIndex.serverFields; // seta os campos que podem ser filtrados
        })
        .catch(response => console.log(response))
        .finally(() => (this.loading = false));
    },
    entryUpdated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationUpdateMessage();
    },
    entryCreated: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationCreateMessage();
    },
    entryDeleted: function(){
      this.loadServerEntries();
      this.$refs.baseIndex.showConfirmationDeleteMessage();
    },
    optionsChange: function(opts) {
      this.options = opts;
      this.loadServerEntries();
    },
    changeSwitch(item){      
      if (item.selected == false){
        this.saleItemLots = this.saleItemLots.filter(function(id){
          return id !== item.id;
        });
      }else{
        this.saleItemLots.push(item.id);
      }
      // console.log(this.saleItemLots);
    },
  }
};

const LOAD_ALL_SEED_PLOT_OPERATIONS = gql `
  query($input: IndexInputObject!) {
    accountContext {
      availableCropLotsIndex(input: $input){
        count
        typeOperators
        serverFields
        availableCropLots {
          id
          name
          newName
          sownDate
          storageName
          varietyName
          sown
          availableQuantity
          saleQuantity
          lossQuantity
          selected
        }
      }
    }
  }
`;

</script>

<style scoped></style>
